import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBezier"><Path fillRule="evenodd" clipRule="evenodd" d="M9 3H3V9H5V15H3V21H9V19H15V21H21V15H19V9H21V3H15V5H9V3ZM7 15V9H9V7H15V9H17V15H15V17H9V15H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezier;
